import { IResponseList } from '@/types/common';
import { IAdminUser, IUpdateAdminAccessRequest } from '@/types/response';
import axiosClient from '../axiosClient';
import { ENDPOINT } from '../endpoint';

class AdminUser {
  getList = (): Promise<IResponseList<IAdminUser>> => {
    return axiosClient.get(ENDPOINT.ADMIN_USER.GET_LIST);
  };

  updateAccess = (id: number, body: IUpdateAdminAccessRequest) => {
    return axiosClient.put(
      ENDPOINT.ADMIN_USER.UPDATE_ACCESS.replace(':id', String(id)),
      body,
    );
  };
}

export const AdminUserService = new AdminUser();
